import { Typography } from "@mui/material";
import { ErrorOutline as ErrorOutlineIcon } from "@mui/icons-material";
import { FileError, FileWithPath } from "react-dropzone";
import { useTranslation } from "react-i18next";
import { styled } from "@mui/material/styles";

export function RejectedFiles(props: {
  rejectedFiles: { file: FileWithPath; errors: FileError[] }[];
  supportedFormats: string | string[] | undefined;
}) {
  const { rejectedFiles } = props;
  const { t } = useTranslation();

  return render();

  function render() {
    if (!rejectedFiles || rejectedFiles.length === 0) return null;

    return (
      <Styles>
        <div className="rejected-files">
          <Typography variant="h5">{t("label.rejectedFiles")}</Typography>
          <ul>
            {rejectedFiles.map((rejectedFile: { file: FileWithPath; errors: FileError[] }, i) => (
              <li key={i}>
                <ErrorOutlineIcon className="icon" />
                <div>
                  {rejectedFile.file.path} - {rejectedFile.file.size} {t("label.bytes")}
                  <ul>
                    {rejectedFile.errors.map((e) => {
                      console.log("🌀 ~ file: RejectedFiles.tsx ~ line 35 ~ e", e);
                      return (
                        <li key={e.code} className="error-message">
                          {renderErrorMessage(e)}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </Styles>
    );
  }

  function renderErrorMessage(e: FileError) {
    switch (e.code) {
      case "file-invalid-type":
        return t("label.fileTypeMustBe", {
          supportedFormats: props.supportedFormats,
        });
      default:
        return e.message;
    }
  }
}

const Styles = styled("div")`
  padding: ${({ theme }) => theme.spacing(3, 0)};
  color: ${({ theme }) => theme.palette.text.primary};

  ul {
    padding: 0;

    li {
      display: flex;
      flex-direction: row;
      gap: 10px;

      &:not(:first-child) {
        padding-top: ${({ theme }) => theme.spacing(1)};
      }

      .icon {
        transform: translateY(-2px);
        color: ${({ theme }) => theme.palette.error.main};
      }
    }
  }
  .error-message {
    color: ${({ theme }) => theme.palette.error.main};
  }
`;
